export const onlyNumber = (event) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);
  if (!/[0-9]/.test(keyValue)) event.preventDefault();
};

export const formatCurrency = (currency, exp = '.') => {
  if (currency === '-') return '-';
  else if (currency) {
    const convertString = `${Math.round(currency)}`;
    const value = `${convertString?.replaceAll(exp, '')}`;
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, exp);
  }
  return '';
};

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{4})(\d{3})(\d{3})$/);
  if (match) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  }
  return null;
};

export const formatPercentage = (percentage, exp = ',') => {
  if (percentage) {
    const convertString = `${percentage}`;
    return convertString.replaceAll('.', exp);
  }
  return '-';
};
